module.exports = __webpack_public_path__ + "e042d52a71369b814bebb853165ca7c2.png";